module.exports = __webpack_public_path__ + "static/media/discord_svg.41484d92.svg";